/**
 * Local promo codes used as fallback when no real cart token is connected to Shopify.
 * When Shopify is wired up, /api/cart/apply-discount delegates to Storefront API and
 * this map is only used in dev / offline mode.
 *
 * type: 'percent' (value = 0..100) | 'fixed' (value in currency units)
 */
export const PROMO_CODES = {
  'WANMAG10': { type: 'percent', value: 10, label: '−10%' },
  'WELCOME':  { type: 'fixed',   value: 200, label: '−200 грн' },
};
